import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Gear } from '@gravity-ui/icons';
import { isAdmin } from '../../services/api';
import { useNavigationEntitlements } from '../../hooks/useNavigationEntitlements';
import { isNavigationKeyAllowed, NAV_KEYS } from '../../utils/navigationEntitlements';
import { openCameraInAdmin, openLocationInAdmin } from '../../utils/camerasDrilldown';

/*
 * Общие элементы шапки «Кадров» и «Оборудования» (FramesPage/EquipmentPage
 * — параллельные страницы, поэтому кнопки живут здесь, а не в каждой).
 */

/**
 * ТЗ №26, FE-CORR-07 FE-002: «Настройка локаций» — только администратору;
 * без прав кнопки в разметке нет. path — { factory, workshop, section, room }
 * страницы.
 */
export const LocationAdminButton = ({ path, className }) => {
  const navigate = useNavigate();
  if (!path?.room || !isAdmin()) return null;

  return (
    <button type="button" className={className} onClick={() => openLocationInAdmin(navigate, path)}>
      <Gear className="g-icon-lead" width={16} height={16} />Настройка локаций
    </button>
  );
};

/**
 * FE-CORR-07 FE-003: «Настройки камеры» на кадрах камеры — форма этой камеры
 * в админке. Только администратору и только при известном id камеры: другой
 * камеры вместо неё не подставляется. path — selectedItems страницы.
 */
export const CameraAdminButton = ({ path, className }) => {
  const navigate = useNavigate();
  const camera = path?.camera;
  if (!camera || camera.id == null || camera.id === '' || !path.room || !isAdmin()) return null;

  return (
    <button type="button" className={className} onClick={() => openCameraInAdmin(navigate, camera, path)}>
      <Gear className="g-icon-lead" width={16} height={16} />Настройки камеры
    </button>
  );
};

/**
 * ТЗ №43: «Прямой эфир» и «Архив» видны по ключам monitoring.live /
 * monitoring.archive. keys = null — навигация не загружена или не
 * поддерживается: ограничений нет. Доступ к данным камеры закрывает backend.
 */
export const CameraVideoButtons = ({
  className,
  canOpenLive,
  liveTitle,
  onOpenLive,
  canOpenArchive,
  onOpenArchive,
}) => {
  const { keys } = useNavigationEntitlements();
  const showLive = isNavigationKeyAllowed(keys, NAV_KEYS.MONITORING_LIVE);
  const showArchive = isNavigationKeyAllowed(keys, NAV_KEYS.MONITORING_ARCHIVE);

  return (
    <>
      {showLive && (
        <button type="button" className={className} onClick={onOpenLive} disabled={!canOpenLive} title={liveTitle}>
          Прямой эфир
        </button>
      )}
      {showArchive && (
        <button type="button" className={className} onClick={onOpenArchive} disabled={!canOpenArchive} title="Архив">
          Архив
        </button>
      )}
    </>
  );
};
